import {connectRefinementList} from 'instantsearch.js/es/connectors';

const renderAvailableStoresRefinement = (renderOptions, isFirstRender) => {
    const {items, refine, widgetParams: {container, translations, attribute, searchable, searchablePlaceholder}} = renderOptions;
    const itemsHTML = items?.reduce((acc, cur, idx) => {
        return `${acc}${itemHTML(cur, idx)}`;
    }, '');

    function itemHTML(item, idx) {
        const {value, label, count, isRefined} = item;
        let storeName = translations['algolia.search.filter.shops.name.' + label];
        let storeAddress = translations['algolia.search.filter.shops.address.' + label];
        if(storeName === undefined) return ``;
        return `<li class="js-filter-store ais-RefinementList-item ${isRefined ? 'ais-RefinementList-item--selected' : ''}"
                    data-address="${storeName} ${storeAddress}">
                    <div class="ais-RefinementList-label" data-filter="${attribute}" data-value="${value}">
                        <input type="checkbox" class="ais-RefinementList-checkbox ${attribute}" value="${value}" ${isRefined ? 'checked' : ''}/>
                        <div class="ais-RefinementList-labelText ais-RefinementList-firstLabelText">
                            ${storeName}
                            <span class="ais-RefinementList-count">${count}</span>
                            <span class="ais-RefinementList-labelText ais-RefinementList-secondLabelText">${storeAddress}</span>
                        </div>
                    </div>
                </li>`;
    }

    function filterItems(container, searchTerm) {
        const stores = container.querySelectorAll('.js-filter-store');
        const noResults = container.querySelector('.js-noResults');

        stores.forEach(store => {
            const text2search = store.dataset?.address?.toLowerCase();
            if (text2search.includes(searchTerm)) {
                store.classList.remove('d-none');
            } else {
                store.classList.add('d-none');
            }
        });

        if (stores.length === container.querySelectorAll('.js-filter-store.d-none').length) {
            noResults.classList.remove('d-none');
        } else {
            noResults.classList.add('d-none');
        }
    }

    if (isFirstRender) {
        const newHeader = document.createElement('div');
        newHeader.className = 'algolia-filter-panel-mobile-header';
        newHeader.innerHTML = `
            <div class="algolia-filter-panel-mobile-header__headline">${translations['algolia.search.filter.title.' + attribute]}</div>   
            <div class="d-flex">
                <button class="js-clear-stores btn btn-filter btn-filter--sm" data-filter="${attribute}">
                    ${translations['algolia.search.filter.clear']}
                </button>
                <button class="js-apply-filter btn-reset algolia-filter-panel-mobile-header__close"
                    data-filter="${attribute}" 
                    aria-label="${translations['algolia.search.filter.close']}">
                    <svg class="icon icon-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </button>
            </div>`;

        const newSearch = document.createElement('div');
        newSearch.className = `ais-RefinementList-searchBox ${searchable ? '' : 'd-none'}`;
        newSearch.innerHTML = `<div class="ais-SearchBox">
                <form role="search" class="ais-SearchBox-form" novalidate>
                    <input class="ais-SearchBox-input" id="js-storeselector__input" name="${attribute}" type="search" placeholder="${searchablePlaceholder}" autocomplete="off" spellcheck="false" maxlength="512" aria-label="${searchablePlaceholder}">
                </form>
            </div>`
        const newList = document.createElement('ul');
        newList.className = 'ais-RefinementList-list';
        const newEmptyResult = document.createElement('div');
        newEmptyResult.className = 'js-noResults ais-RefinementList-noResults d-none';
        newEmptyResult.textContent = translations['algolia.search.filter.noResults'];
        const wrapper = document.createElement('div');
        wrapper.className = 'ais-RefinementList';
        wrapper.appendChild(newSearch);
        wrapper.appendChild(newList);
        wrapper.appendChild(newEmptyResult);

        const newButtons = document.createElement('div');
        newButtons.className = 'algolia-filter-panel-buttons';
        newButtons.innerHTML = `
            <button class="js-clear-stores btn btn-filter btn-filter--sm d-none d-md-block" data-filter="${attribute}">
                ${translations['algolia.search.filter.clear']}
            </button>
            <button class="js-apply-filter btn btn-filter btn-filter--active btn-filter--sm btn-block" data-filter="${attribute}">
                ${translations['algolia.search.filter.apply']}
            </button>`;

        container.appendChild(newHeader);
        container.appendChild(wrapper);
        container.appendChild(newButtons);
        container.addEventListener('click', ({target}) => {
            const parent = target.closest('.ais-RefinementList-item');
            if (!parent) {
                return;
            }
            const input = parent.querySelector('input');
            if (input) {
                refine(input.value);
                container.querySelector('#js-storeselector__input').value = '';
            }
        });
        container.querySelector('#js-storeselector__input').addEventListener('keyup', ({target}) => {
            const searchQuery = target.value.toLowerCase();
            filterItems(container, searchQuery);
        });
        container.querySelectorAll('.js-clear-stores').forEach((element) => {
            element.addEventListener('click', () => {
                container.querySelector('#js-storeselector__input').value = '';
                document.querySelector(`#js-clear-refinement_${attribute} button`).click();
                filterItems(container, '');
            })
        });
        return;
    }

    container.querySelector('.ais-RefinementList-list').innerHTML = `${itemsHTML}`;
};

// Create the custom widget
const customAvailableStores = connectRefinementList(
    renderAvailableStoresRefinement
);

export {customAvailableStores};
